export default __webpack_public_path__ + "static/media/englishStar.420d8e9c.jpeg";